export default {
  orders: [],
  selectedOrder: {},
  periods: [],
  selectedPeriod: {},
};
